import React from "react";

export const IcoDash = ({ s = 16 }) => (
  <svg
    width={s}
    height={s}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="2" width="7" height="7" rx="1.5" />
    <rect x="11" y="2" width="7" height="7" rx="1.5" />
    <rect x="2" y="11" width="7" height="7" rx="1.5" />
    <rect x="11" y="11" width="7" height="7" rx="1.5" />
  </svg>
);

export const IcoLogout = ({ s = 16 }) => (
  <svg
    width={s}
    height={s}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M8 3H4a1 1 0 00-1 1v12a1 1 0 001 1h4M13 14l4-4-4-4M17 10H7" />
  </svg>
);

export const IcoChevron = ({ s = 14, dir = "right" }) => {
  const r = { right: 0, left: 180, down: 90, up: -90 }[dir];

  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      style={{ transform: `rotate(${r}deg)`, transition: "transform 0.2s" }}
    >
      <path d="M8 5l5 5-5 5" />
    </svg>
  );
};

export const IcoMenu = ({ s = 18 }) => (
  <svg
    width={s}
    height={s}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
  >
    <path d="M3 6h14M3 10h14M3 14h14" />
  </svg>
);

export const IcoClose2 = ({ s = 16 }) => (
  <svg
    width={s}
    height={s}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <path d="M5 5l10 10M15 5L5 15" />
  </svg>
);

export const IcoSun = () => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="10" cy="10" r="3.5" />
    <path d="M10 2v2M10 16v2M2 10h2M16 10h2M4.6 4.6l1.4 1.4M14 14l1.4 1.4M4.6 15.4l1.4-1.4M14 6l1.4-1.4" />
  </svg>
);

export const IcoMoon = () => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 11a7 7 0 11-8-8 5.5 5.5 0 008 8z" />
  </svg>
);
